import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpHeaders, HttpHeaderResponse, HttpRequest } from '@angular/common/http';
//import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
// import 'rxjs/add/operator/map';
import { map ,delay} from 'rxjs/operators';

import { AppGlobals } from '../shared/app.global';



  

@Injectable()
export class ClassroomService {

    callurl: string = '';
  
    clcd:string;
    aycd:string;
    usid:string;
    
        constructor(private http: HttpClient,private _global: AppGlobals) {
    
           this.clcd=localStorage.getItem('clcd');
           this.aycd=localStorage.getItem('aycd');
           this.usid=localStorage.getItem('usid');
         
           this.callurl=_global.baseAPIUrl;
         }

         
         getdatetoday()
         {
          let d: Date = new Date();
          var mnth;
          var day='';
          //let todayDate = {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()};
          if(d.getMonth()>=10)
          {
            mnth=d.getMonth()+1;
          }
          else{
           // mnth='0'+d.getMonth()+1;
           mnth=d.getMonth()+1;
           mnth='0'+mnth;
          }
       
          if(d.getDate()>=10)
          {
            day=d.getDate().toString();
          }
          else{
            day='0'+d.getDate();
          }
          let todayDate =  d.getFullYear()+'-'+ mnth+'-'+day;
            
       return todayDate;
       
         }
        
  by_sp_student(clid:number,secid:number,brid:string): Observable<any> {
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    return this.http.get(this._global.baseAPIUrl + 'sp_student/'+clid+'/'+secid+'/dbnm/'+clcd+'/'+aycd+'/'+brid)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data.by_sp_clsSec;
        }));
}

getstudents_clwise(clid,secid,crid): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  
  return this.http.post(this.callurl + 'selstudent_clwise',{clcd:this.clcd,aycd:this.aycd,clid:clid,scid:secid,crid:crid})
  .pipe(map((data: any) => {
          console.log('retres-data', data);
          return data.stulst;
          
      }));
}

searchstudents(sertxt): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  
  return this.http.post(this.callurl + 'searchstudents',{clcd:this.clcd,aycd:this.aycd,stunm:sertxt})
  .pipe(map((data: any) => {
          console.log('retres-data', data);
          return data.stulst;
          
      }));
}


select_rmk_reportcard(modeldata: any): Observable<any> {

  debugger
  modeldata.usid=this.usid;
  return this.http.post(this._global.baseAPIUrl + 'select_rmk_reportcard', modeldata)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.by_sp_reportcard;
      }));
}


select_sp_reportcard(modeldata: any): Observable<any> {

    debugger
    modeldata.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'select_sp_reportcard', modeldata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data.by_sp_reportcard;
        }));
}
// $arr['attstatus']=(boolean)$data['attstatus'];
       
// $arr['rid']=$data['rid'];
// $arr['maxsc']=$data['maxsc'];
// $arr['minsc']=$data['minsc'];
// $arr['score']=$data['score'];
// $arr['stuid']=$data['stuid'];
// $arr['name']=$data['name'];
// $arr['suid']=$data['suid'];
select_sp_marksdetail(modeldata: any): Observable<any> {
        
  debugger
  modeldata.usid=this.usid;
  return this.http.post(this._global.baseAPIUrl + 'select_sp_marksdetail', modeldata)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
      }));
}


loop_reportcard(modeldata: any): Observable<any> {
  modeldata.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'loop_reportcard', modeldata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data
        }));
}


loop_reportcard_rmk(modeldata: any): Observable<any> {
  modeldata.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'loop_reportcard_remarks', modeldata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data
        }));
}

Savercremarks(modeldata: any): Observable<any> {
  modeldata.usid=this.usid;
  modeldata.clcd=this.clcd;
  modeldata.aycd=this.aycd;
    return this.http.post(this._global.baseAPIUrl + 'Savercremarks', modeldata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data
        }));
}


getcomclnote(clid,secid,subid,crid): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  
  return this.http.post(this.callurl + 'getcomclnote',{clcd:this.clcd,aycd:this.aycd,clid:clid,scid:secid,suid:subid,usid:this.usid,crid:crid})
  .pipe(map((data: any) => {
          console.log('retres-data', data);
          return data.notelst;
          
      }));
}


getcomwksheet(clid,crid): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  
  return this.http.post(this.callurl + 'getcomwksheet',{clcd:this.clcd,aycd:this.aycd,clid:clid,usid:this.usid,crid:crid})
  .pipe(map((data: any) => {
          console.log('retres-data', data);
          return data.notelst;
          
      }));
}

getalbum(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  
  let clcd=this.clcd;
  let aycd=this.aycd;
 // var pstdata={clcd:this.clcd,aycd:this.aycd,nfid:nfid};
 // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
  return this.http.get(this.callurl + 'getalbum/'+this.clcd+'/'+this.aycd)
      .pipe(map((data: any) => {
          return data.arralbum;
      }));
}

getalbumd(abid): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  
  let clcd=this.clcd;
  let aycd=this.aycd;
 // var pstdata={clcd:this.clcd,aycd:this.aycd,nfid:nfid};
 // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
  return this.http.get(this.callurl + 'getalbumd/'+this.clcd+'/'+this.aycd+'/'+abid)
      .pipe(map((data: any) => {
          return data.arralbum;
      }));



}

deletalbumd(obj): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  
  return this.http.post(this.callurl + 'deletalbumd',{clcd:this.clcd,aycd:this.aycd,abdid:obj.abdid,imgpath:obj.imgpath,usid:this.usid})
  .pipe(map((data: any) => {
          console.log('retres-data', data);
          return data;
          
      }));
}

deletalbumh(obj): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  
  return this.http.post(this.callurl + 'deletalbumh',{clcd:this.clcd,aycd:this.aycd,abid:obj.abid,usid:this.usid})
  .pipe(map((data: any) => {
          console.log('retres-data', data);
          return data;
          
      }));
}
getcomclnoteda(cnid): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  
  return this.http.post(this.callurl + 'getcomclnoteda',{clcd:this.clcd,aycd:this.aycd,cnid:cnid,usid:this.usid})
  .pipe(map((data: any) => {
          console.log('retres-data', data);
          return data.notedalst;
          
      }));
}


delnoteda(nfid) {
  debugger
  let clcd=this.clcd;
  let aycd=this.aycd;
 // var pstdata={clcd:this.clcd,aycd:this.aycd,nfid:nfid};
 // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
  return this.http.get(this._global.baseAPIUrl + 'delcomclda/'+this.clcd+'/'+this.aycd+'/'+nfid)
      .pipe(map((data: any) => {
          return data;
      }));
  }

  
delclnote(cnid) {
  debugger
  let clcd=this.clcd;
  let aycd=this.aycd;
 // var pstdata={clcd:this.clcd,aycd:this.aycd,nfid:nfid};
 // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
  return this.http.get(this._global.baseAPIUrl + 'delclnote/'+this.clcd+'/'+this.aycd+'/'+cnid)
      .pipe(map((data: any) => {
          return data;
      }));
  }


    
  delcomwksheet(cnid) {
  debugger
  let clcd=this.clcd;
  let aycd=this.aycd;
 // var pstdata={clcd:this.clcd,aycd:this.aycd,nfid:nfid};
 // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
  return this.http.get(this.callurl + 'delcomwksheet/'+this.clcd+'/'+this.aycd+'/'+cnid)
      .pipe(map((data: any) => {
          return data;
      }));
  }
savecomclnote(objnote): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  objnote.clcd=this.clcd;
  objnote.aycd=this.aycd;
  objnote.usid=this.usid;
  return this.http.post(this.callurl + 'savecomclnote',objnote)
  .pipe(map((data: any) => {
          console.log('retres-data', data);
          return data;
          
      }));
}

savealbum(objnote): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  objnote.clcd=this.clcd;
  objnote.aycd=this.aycd;
  objnote.usid=this.usid;
  return this.http.post(this.callurl + 'savealbum',objnote)
  .pipe(map((data: any) => {
          console.log('retres-data', data);
          return data;
          
      }));
}


marksumsub(attdtdata: any): Observable<any> {
  attdtdata.clcd=this.clcd;
  attdtdata.aycd=this.aycd;
  //attdtdata.oprtype1="sum_subwise";
  return this.http.post(this._global.baseAPIUrl + 'marksumsub', attdtdata)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.marksum;
      }));
}

marksumsubwp(attdtdata: any): Observable<any> {
  attdtdata.clcd=this.clcd;
  attdtdata.aycd=this.aycd;
  //attdtdata.oprtype1="sum_subwise";
  return this.http.post(this._global.baseAPIUrl + 'marksumsubwp', attdtdata)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.marksumwp;
      }));
}
marksumgrade(attdtdata: any): Observable<any> {
  attdtdata.clcd=this.clcd;
  attdtdata.aycd=this.aycd;
  //attdtdata.oprtype1="sum_subwise";
  return this.http.post(this._global.baseAPIUrl + 'marksumgrade', attdtdata)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.marksum;
      }));
}

uploadcomclnoteda(data: File,nfid,fpath,ftype,fnm): Observable<any> {
  /// this._url = 'http://localhost:4200/XXXXXXXXXX/uploadFile';
debugger
  const formData: FormData = new FormData();
  //console.log("stuid",bkid)
  if(ftype=='File')
  {
  formData.append('Image', data, data.name);
  }
    formData.append('cnid', nfid);
    formData.append('fpath', fpath);
    formData.append('ftype', ftype);
    formData.append('fnm', fnm);
    formData.append('clcd', this.clcd);
    formData.append('aycd', this.aycd);
    formData.append('crby', this.usid);
    console.log("formData",formData);
   return this.http.post(this._global.baseAPIUrl + 'uploadcomclnoteda', formData)
   .pipe(map((data: any) => {
       console.log('retres', data);
       return data
   }));
}

uploadcomwksheet(data: File,obj:any): Observable<any> {
  /// this._url = 'http://localhost:4200/XXXXXXXXXX/uploadFile';
debugger
  const formData: FormData = new FormData();
  //console.log("stuid",bkid)
 
  formData.append('Image', data, data.name);
    formData.append('rid', obj.rid);
    formData.append('clid', obj.clid);
    formData.append('crid', obj.crid);
    formData.append('fnm', obj.fnm);
    formData.append('clcd', this.clcd);
    formData.append('aycd', this.aycd);
    formData.append('usid', this.usid);
    formData.append('docpath', obj.fpath);
    formData.append('oprtype', obj.oprtype);
    console.log("formData",formData);
   return this.http.post(this._global.baseAPIUrl + 'uploadcomwksheet', formData)
   .pipe(map((data: any) => {
       console.log('retres', data);
       return data
   }));
}

uploadalbimages(data: File,obj:any): Observable<any> {
  /// this._url = 'http://localhost:4200/XXXXXXXXXX/uploadFile';
debugger
  const formData: FormData = new FormData();
  //console.log("stuid",bkid)
 
  formData.append('Image', data, data.name);
    formData.append('abid', obj);
    // formData.append('clid', obj.clid);
    // formData.append('crid', obj.crid);
    // formData.append('fnm', obj.fnm);
    formData.append('clcd', this.clcd);
    formData.append('aycd', this.aycd);
    formData.append('usid', this.usid);
    //formData.append('docpath', obj.fpath);
    //formData.append('oprtype', obj.oprtype);
    console.log("formData",formData);
   return this.http.post(this._global.baseAPIUrl + 'uploadalbimages', formData)
   .pipe(map((data: any) => {
       console.log('retres', data);
       return data
   }));
}



uploadphoto(data: File,objpst:any): Observable<any> {
  /// this._url = 'http://localhost:4200/XXXXXXXXXX/uploadFile';
debugger
  const formData: FormData = new FormData();
  //console.log("stuid",bkid)
  formData.append('Image', data, data.name);
    
    formData.append('clid', objpst.clid);
    formData.append('scid', objpst.scid);
    formData.append('asid', objpst.asid);
    formData.append('astpid', objpst.astpid);
    formData.append('crid', objpst.crid);
    formData.append('sucbid', objpst.sucbid);
    
    formData.append('clcd', this.clcd);
    formData.append('aycd', this.aycd);
    formData.append('usid', this.usid);
    console.log("formData",formData);
   return this.http.post(this._global.baseAPIUrl + 'uploadmarks', formData)
   .pipe(map((data: any) => {
       console.log('retres', data);
       return data
   }));
}


sel_evaluationentry(asid:number,astpid:number,oprtype): Observable<any> {
  let clcd=localStorage.getItem('clcd');
  let aycd=localStorage.getItem('aycd');
  return this.http.get(this._global.baseAPIUrl + 'sel_evaluationentry/'+clcd+'/'+aycd+'/'+asid+'/'+astpid+'/'+oprtype)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.evclasslst;
      }));
}

getstuinfoformarkssms(objnote): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  objnote.clcd=this.clcd;
  objnote.aycd=this.aycd;
  objnote.usid=this.usid;
  return this.http.post(this.callurl + 'getstuinfoformarkssms',objnote)
  .pipe(map((data: any) => {
          console.log('retres-data', data);
          return data.stulst;
          
      }));
}


sendmarkssms(empdata: any): Observable<any> {
  empdata.ayid='16';
  empdata.usid=this.usid;
  empdata.clcd=this.clcd;
  empdata.aycd=this.aycd;
  return this.http.post(this._global.baseAPIUrl + 'smsmarks', empdata)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
      }));
}
generatemarks(objnote): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  objnote.clcd=this.clcd;
  objnote.aycd=this.aycd;
  objnote.usid=this.usid;
  return this.http.post(this.callurl + 'Generate_assesssmarks',objnote)
  .pipe(map((data: any) => {
          console.log('retres-data', data);
          return data;
          
      }));
}

generatemarksstu(objnote): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  objnote.clcd=this.clcd;
  objnote.aycd=this.aycd;
  objnote.usid=this.usid;
  return this.http.post(this.callurl + 'Generate_assesssmarks_student',objnote)
  .pipe(map((data: any) => {
          console.log('retres-data', data);
          return data;
          
      }));
}


generatemarkssub(objnote): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  objnote.clcd=this.clcd;
  objnote.aycd=this.aycd;
  objnote.usid=this.usid;
  return this.http.post(this.callurl + 'Generate_assesssmarks_subject',objnote)
  .pipe(map((data: any) => {
          console.log('retres-data', data);
          return data;
          
      }));
}

delmarkssub(objnote): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  objnote.clcd=this.clcd;
  objnote.aycd=this.aycd;
  objnote.usid=this.usid;
  return this.http.post(this.callurl + 'delete_assesssmarks_subject',objnote)
  .pipe(map((data: any) => {
          console.log('retres-data', data);
          return data;
          
      }));
}

uploadmarksheet(objnote): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  objnote.clcd=this.clcd;
  objnote.aycd=this.aycd;
  objnote.usid=this.usid;
  return this.http.post(this.callurl + 'Generate_assesssmarks',objnote)
  .pipe(map((data: any) => {
          console.log('retres-data', data);
          return data;
          
      }));
}


getresults(obj): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  var objprof:any={};

  return this.http.get(this.callurl + 'results/'+this.clcd+'/'+this.aycd+'/'+obj.stuid+'/'+obj.clid+'/'+obj.scid+'/0/0')
  .pipe(map((data: any) => {
          console.log('notification', data);
          return data;
          
      }));
}

savecandidate(obj,arrdata): Observable<any> {
  obj.usid=this.usid;
  obj.clcd=this.clcd;
  obj.aycd=this.aycd;
  obj.stuarr=arrdata;
    return this.http.post(this._global.baseAPIUrl + 'savevotcandidate', obj)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data;
        }));
}


getcanlist(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  var objprof:any={};

  return this.http.get(this.callurl + 'getvotcandidate/'+this.clcd+'/'+this.aycd)
  .pipe(map((data: any) => {
          console.log('notification', data);
          return data.canlist;
          
      }));
}

getstudents_bytype(clid,secid,crid,oprtype): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  
  return this.http.post(this.callurl + 'selstudent_bytype',{clcd:this.clcd,aycd:this.aycd,clid:clid,scid:secid,crid:crid,oprtype:oprtype})
  .pipe(map((data: any) => {
          console.log('retres-data', data);
          return data.stulst;
          
      }));
}


uploadsymbol(data: File,objpst:any): Observable<any> {
  /// this._url = 'http://localhost:4200/XXXXXXXXXX/uploadFile';
debugger
  const formData: FormData = new FormData();
  //console.log("stuid",bkid)
  formData.append('Image', data, data.name);
    
    formData.append('memid', objpst.canid);
    // formData.append('scid', objpst.scid);
    // formData.append('asid', objpst.asid);
    // formData.append('astpid', objpst.astpid);
    // formData.append('crid', objpst.crid);
    // formData.append('sucbid', objpst.sucbid);
    
    formData.append('clcd', this.clcd);
    formData.append('aycd', this.aycd);
    formData.append('usid', this.usid);
    console.log("formData",formData);
   return this.http.post(this._global.baseAPIUrl + 'uploadcandidatesymbol', formData)
   .pipe(map((data: any) => {
       console.log('retres', data);
       return data
   }));
}


updcandidatepost(obj): Observable<any> {
  obj.usid=this.usid;
  obj.clcd=this.clcd;
  obj.aycd=this.aycd;
  // obj.stuarr=arrdata;
    return this.http.post(this._global.baseAPIUrl + 'savecanpost', obj)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data;
        }));
}


savevoter(obj,arrdata,type,boothid): Observable<any> {
  obj.usid=this.usid;
  obj.clcd=this.clcd;
  obj.aycd=this.aycd;
  obj.type=type;
  obj.stuarr=arrdata;
  obj.boothid=boothid;
    return this.http.post(this._global.baseAPIUrl + 'savevoters', obj)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data;
        }));
}


getvotlist(oprtype,crid,clid,scid): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  var objprof:any={};

  return this.http.get(this.callurl + 'getvoters/'+this.clcd+'/'+this.aycd+'/'+oprtype+'/'+crid+'/'+clid+'/'+scid)
  .pipe(map((data: any) => {
          console.log('notification', data);
          return data.canlist;
          
      }));
}

delvoter(id): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  var objprof:any={};

  return this.http.get(this.callurl + 'delvoter/'+this.clcd+'/'+this.aycd+'/'+id)
  .pipe(map((data: any) => {
          console.log('notification', data);
          return data;
          
      }));
}


delcan(id): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  var objprof:any={};

  return this.http.get(this.callurl + 'delcan/'+this.clcd+'/'+this.aycd+'/'+id)
  .pipe(map((data: any) => {
          console.log('notification', data);
          return data;
          
      }));
}
}